import React from 'react';

function usagePerPeriod(usagePerPeriod: any) {
  if (usagePerPeriod.text === "") {
    return (
      <div>
        <span>{Number(usagePerPeriod.data.usage).toFixed(2)} kWh</span>
      </div>
    )
  } else {
    return (
      <span>{Number(usagePerPeriod.text).toFixed(2)} kWh</span>
    )
  }
}
export default usagePerPeriod; 